import { Box } from '@material-ui/core';
import { formatMoney } from '@nemuru-eng/js-api-client';

import { ReportsListRowProps } from '@/components/modules/Reports/ReportsList/types/ReportsListRowProps';
import { Text } from '@/components/shared/components/Text';

export const totalAdjustmentsAmountFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'adjustments_amount',
    align: 'right',
    sortable: false,
    headerName: (
      <Box minWidth={'120px'} textAlign={'end'}>
        <Text tId={'ADJUSTMENTS_AMOUNT'} />
      </Box>
    ),
    renderCell: (rowData: ReportsListRowProps) => {
      const totalAdjustedAmount = rowData.row.payouts.reduce((acc, payout) => acc + payout.adjustmentsAmount.amount, 0);
      return (
        <Box minWidth={'120px'} textAlign={'end'}>
          {formatMoney({ value: totalAdjustedAmount, currency: rowData.row.currency })}
        </Box>
      );
    },
  };
};
